import React from "react";
import { Button, Tag, Tooltip, Typography } from "antd";
import { PlusOutlined, SwapOutlined } from "@ant-design/icons";
import {
  getCurrencyColumn,
  getBalanceUpdatedColumn,
  getWalletUpdatedColumn,
  getTotalBalanceColumn,
  getWalletBalanceColumn,
} from "../accounts/accountColumnHelpers";

function ActionButtons({
  record,
  onManual,
  onTransfer,
  canOpenManualModal = false,
}) {
  const isActive = Boolean(record?.is_active);

  const stopPropagation = (event) => {
    event?.stopPropagation?.();
  };

  const handleManual = (event) => {
    stopPropagation(event);
    onManual?.(record);
  };

  const handleTransfer = (event) => {
    stopPropagation(event);
    onTransfer?.(record);
  };

  return (
    <div
      className="flex items-center justify-center gap-2"
      onClick={stopPropagation}
    >
      {canOpenManualModal && (
        <Tooltip title="Гараар орлогын гүйлгээ шивэх">
          <Button
            size="middle"
            className="flex h-9 items-center rounded-xl border-slate-200 px-3 font-medium shadow-sm hover:border-slate-300 hover:bg-slate-50"
            icon={<PlusOutlined />}
            onClick={handleManual}
            disabled={!isActive}
          >
            Гараар
          </Button>
        </Tooltip>
      )}

      <Tooltip title="Данс хооронд шилжүүлэг хийх">
        <Button
          size="middle"
          className="flex h-9 items-center rounded-xl px-3 font-medium shadow-sm"
          icon={<SwapOutlined />}
          onClick={handleTransfer}
          disabled={!isActive}
        >
          Шилжүүлэг
        </Button>
      </Tooltip>
    </div>
  );
}

export function createInstitutionWalletColumns({
  onManual,
  onTransfer,
  canOpenManualModal = false,
  bulkSelectMode = false,
}) {
  const columns = [];

  if (!bulkSelectMode) {
    columns.push({
      title: "Үйлдлүүд",
      key: "actions",
      width: canOpenManualModal ? 300 : 180,
      align: "center",
      fixed: "left",
      render: (_, record) => (
        <ActionButtons
          record={record}
          onManual={onManual}
          onTransfer={onTransfer}
          canOpenManualModal={canOpenManualModal}
        />
      ),
    });
  }

  columns.push(
    {
      title: "Төлөв",
      dataIndex: "is_active",
      key: "is_active",
      width: 120,
      align: "center",
      render: (value) => (
        <Tag color={value ? "green" : "red"}>
          {value ? "ИДЭВХТЭЙ" : "ИДЭВХГҮЙ"}
        </Tag>
      ),
    },
    {
      title: "Данс / Банк",
      key: "accountBank",
      width: 240,
      render: (_, record) => {
        const account = record?.accountNumber;
        const bank = record?.bank;

        return (
          <div className="leading-tight">
            <div className="font-medium mb-1">
              {account ? (
                <Typography.Text 
                  copyable={{
                  text: account,
                  tooltips: ["Хуулах", "Хуулсан!"],
                }}
                >
                  {account}
                </Typography.Text>
              ) : (
                "-"
              )}
            </div>

            <div className="text-xs text-gray-500 mt-1">
              {bank ? bank.replaceAll("_", " ") : "-"}
            </div>
          </div>
        );
      },
    },
    getCurrencyColumn(),
    {
      ...getTotalBalanceColumn(),
      align: "right",
    },
    {
      ...getWalletBalanceColumn(),
      align: "right",
    },
    getBalanceUpdatedColumn(),
    getWalletUpdatedColumn()
  );

  return columns;
}